import profile from "./API/profile";
import portfolio from "./API/portfolio";
import image from "./API/image-upload";
import tag from "./API/tag";
import collection from "./API/Collection.Service";
import categoty from "./API/Category";
import auth from "./API/Auth.Service";
import page from "./API/Page.Service";
import contact from "./API/Contact.Service";
import Common from "./API/Common.Service";

export default {
  profile,
  portfolio,
  image,
  tag,
  collection,
  categoty,
  auth,
  page,
  contact,
  Common,
};
